import React from 'react';
import { CircularProgress } from '@mui/material';
import logo from '../assets/uss.png'; // Update with your actual logo path

interface LoadingProps {
  message?: string;
  size?: number;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit';
  logoSrc?: string;
}

const Loading: React.FC<LoadingProps> = ({
  message = 'Loading...',
  size = 60,
  color = 'primary',
  logoSrc = logo, // Default to your logo
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
        <CircularProgress size={size} color={color} />
        <img src={logoSrc} alt="Company Logo" className="w-24 my-4" />
        <p className="text-lg font-medium">{message}</p>
      </div>
    </div>
  );
};

export default Loading;